import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";

// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import {
  redirectToLogout,
  zeroFill,
  numericSortFunc,
  dateSortFunc,
} from "common/SharedFn";
import { getSubscriptionDetails } from "../../network/ApiAxios";
import { ArrowBack } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SubscriptionPaymentsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  let history = useHistory();
  var currentSubscriptionId = props.match.params.id;

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchSubscription = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getSubscriptionDetails(currentSubscriptionId);
      const { data } = response;
      if (data.result.isSuccess) {
        setData(
          data.data.subscriptionPaymentsById.map((prop) => makeTableRow(prop))
        );
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code === -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch details "+ex);
    }
    setIsLoading(false);
  };

  useAsyncEffect(async () => {
    fetchSubscription();
  }, []);

  const makeTableRow = (info) => {
    info.addedOnText = dateFormat(
      new Date(info.addedOn),
      "d-mmm-yyyy hh:MM TT"
    );

    info.feeRounded = 0;
    info.feeVatRounded = 0;
    info.feeWithVatRounded = 0;
    info.net = 0;
    info.priceWithoutDiscountAndVat = 0;
    info.amount = 0;
    info.discountedAmount = 0;
    info.vatFormatted = 0;
    info.discountAmount = 0;
    info.amount = info.finalPrice.toFixed(3);
    info.priceWithoutDiscountAndVat = (
      info.price - info.discountAmount
    ).toFixed(3);
    info.discountedAmount = (info.finalPrice - info.vat).toFixed(3);
    info.vatFormatted = info.vat.toFixed(3);
    info.discountAmount = info.discountAmount.toFixed(3);
    info.walletBalanceUsedFormatted = info.walletBalanceUsed.toFixed(3);
    if (info.transactionDetailByTransactionId != null) {
      if (info.transactionDetailByTransactionId.fee != null) {
        info.feeRounded = info.transactionDetailByTransactionId.fee.toFixed(3);
      }
      if (info.transactionDetailByTransactionId.feeVat != null) {
        info.feeVatRounded =
          info.transactionDetailByTransactionId.feeVat.toFixed(3);
      }
      if (info.transactionDetailByTransactionId.feeWithVat != null) {
        info.feeWithVatRounded =
          info.transactionDetailByTransactionId.feeWithVat.toFixed(3);
      }
      if (info.transactionDetailByTransactionId.feeWithVat != null) {
        info.net = (
          info.finalPrice - info.transactionDetailByTransactionId.feeWithVat
        ).toFixed(3);
      }
    }

    if(info.transactionDetailByTransactionId != null){
      info.paymentMethodName = info.transactionDetailByTransactionId.paymentMethodByPaymentMethodId.name;
      if(info.walletBalanceUsed > 0){
        info.paymentMethodName = info.paymentMethodName +" + Wallet";
      }
    }
    else{
      info.paymentMethodName = "doobi Wallet";
    }

    return {
      ...info,
      transactionIdForm: info.transactionId != null ? "T" + zeroFill(info.transactionId, 5) : 'NA',
      isSuccessText: info.isSuccess === 1 ? "Yes" : "No",
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{ width: "100%" }}>
                <ToolkitProvider
                  data={data}
                  keyField="id"
                  columns={[
                    {
                      dataField: "id",
                      text: "ID",
                      sort: true,
                      style: { whiteSpace: "normal" },
                    },
                    {
                      dataField: "transactionIdForm",
                      text: "Transaction ID",
                      sort: true,
                      style: { whiteSpace: "normal" },
                    },
                    {
                      dataField: "isSuccessText",
                      text: "Is Successful",
                      sort: true,
                      style: { whiteSpace: "normal" },
                    },
                    {
                      dataField:
                        "paymentMethodName",
                      text: "Payment Method",
                      sort: true,
                      style: { whiteSpace: "normal" },
                    },
                    {
                      dataField: "couponCode",
                      text: "Coupon Code",
                      sort: true,
                      style: { whiteSpace: "normal" },
                    },
                    {
                      dataField: "amount",
                      text: "Price with VAT",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "discountAmount",
                      text: "Discount",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "discountedAmount",
                      text: "Discounted Price",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "vatFormatted",
                      text: "VAT Order",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "priceWithoutDiscountAndVat",
                      text: "Price",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "feeRounded",
                      text: "PG Fees",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "feeVatRounded",
                      text: "PG Fees VAT",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "feeWithVatRounded",
                      text: "PG Fees With VAT",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "net",
                      text: "Net",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "walletBalanceUsedFormatted",
                      text: "Wallet Balance Used",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "addedOnText",
                      text: "Record Datetime",
                      sort: true,
                      sortFunc: dateSortFunc,
                      style: { whiteSpace: "normal" },
                    },
                  ]}
                  search
                  exportCSV
                >
                  {(props) => (
                                      <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">
                        Subscription{" "}
                        {"S" + zeroFill(currentSubscriptionId, 5) + " "} Payment
                        Records
                      </Box>
                    </Box>
                      </>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                    <BootstrapTable
                        ref={componentRef}
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={true}
                        striped={true}
                        //filter={ filterFactory() }
                        noDataIndication={() =>
                          isLoading ? (
                            <Box
                              component={Grid}
                              container
                              justifyContent="center"
                              className="justify-content-center"
                            >
                              <div
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                <LoadingAnimation />{" "}
                              </div>
                            </Box>
                          ) : (
                            <h4>No Records</h4>
                          )
                        }
                        id="main-table"
                      />
                    </div>
                    </>
                  )}
                </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default SubscriptionPaymentsTable;
